export const AbsObjectValues = (obj, fields) => {
  const result = { ...obj };
  Object.keys(obj).forEach((key) => {
    if (fields.includes(key)) {
      result[key] = Math.abs(obj[key]);
    }
  });
  return result;
};

export const parseDateWithoutTimezone = (dateString) => {
  const clean = dateString.replace('Z', '');
  return new Date(clean);
};

export function formatFrenchDate(dateString) {
  if (!dateString || dateString == 'undefined') return '--/--/----';
  return dateString ? new Intl.DateTimeFormat('fr-FR').format(new Date(dateString)) : '--/--/----';
}

export function formatFrenchDateTime(dateString) {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function toFrenchDateTime(dateString) {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}`;
}

export const TVA = 1.2;

export const normalize = (str) =>
  str
    ?.toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') || '';

export const MONO =
  "'Inter', 'Segoe UI', system-ui, -apple-system, Roboto, 'Helvetica Neue', Arial, sans-serif";
